/* Bundle selector as stacked radio rows, pickers inside the selected row.
   Figures come from window.IF_ROW_PRICES so a price test is a one-file change.
   It owns no state: it drives the original controls by clicking them, so
   pricing, add-to-cart and the gift ladder keep working. The originals are
   hidden, never removed, for that reason. */
(function(){
var P=window.IF_DESIGNS||[];
var PR=window.IF_ROW_PRICES||[
{price:'29.95',was:'44.95',each:null},
{price:'49.95',was:'89.90',each:'$24.98 each'},
{price:'64.95',was:'134.85',each:'$21.65 each'}
];
var ROWS=[
{n:1,title:'1 MASK',  sub:'1x Ice Freaks Ski Mask',  price:PR[0].price, was:PR[0].was, each:PR[0].each, badge:null},
{n:2,title:'2 MASKS', sub:'2x Ice Freaks Ski Masks', price:PR[1].price, was:PR[1].was, each:PR[1].each, badge:'MOST POPULAR'},
{n:3,title:'3 MASKS', sub:'3x Ice Freaks Ski Masks', price:PR[2].price, was:PR[2].was, each:PR[2].each, badge:'BEST VALUE'}
];
var sel=1, wrap=null, built=false;

function el(t,s,h){var e=document.createElement(t);if(s)e.setAttribute('style',s);if(h!==undefined)e.innerHTML=h;return e;}
function gp(id){for(var i=0;i<P.length;i++){if(P[i].id===id)return P[i];}return P[0];}

function currentDesign(k){
var units=document.getElementById('if-units');
if(!units||!units.children[k])return P[0]?P[0].id:null;
var btns=units.children[k].querySelectorAll('button');
for(var i=0;i<btns.length;i++){
var bg=(btns[i].style.background||'').toLowerCase();
if(bg.indexOf('rgb(18, 22, 28)')>-1||bg.indexOf('#12161c')>-1){
var nm=btns[i].getAttribute('title');
for(var j=0;j<P.length;j++){if(P[j].name===nm)return P[j].id;}
}
}
return P[0]?P[0].id:null;
}

function pickBundle(n){
var hidden=document.getElementById('if-bundles');
if(!hidden)return;
var btns=hidden.querySelectorAll('button');
if(btns[n-1])btns[n-1].click();
sel=n;
setTimeout(render,60);
}

function pickDesign(k,id){
var units=document.getElementById('if-units');
if(!units||!units.children[k])return;
var target=gp(id);
var btns=units.children[k].querySelectorAll('button');
for(var i=0;i<btns.length;i++){
if(btns[i].getAttribute('title')===target.name){btns[i].click();break;}
}
setTimeout(render,60);
}

function pickerLine(label,k){
var cur=gp(currentDesign(k));
var line=el('div','display:flex; align-items:center; gap:10px;');
line.innerHTML='<span style="font-size:10.5px; font-weight:800; letter-spacing:.8px; color:#5B6672; width:52px; flex-shrink:0;">'+label+'</span>'+
'<img src="'+cur.img+'" alt="'+cur.name+'" style="width:40px; height:40px; border-radius:8px; object-fit:cover; flex-shrink:0; background:#EFF1F4; border:1px solid #F0CBBB;">';
var s=document.createElement('select');
s.setAttribute('style','flex:1; min-width:0; border:1.5px solid #FF4D14; border-radius:9px; padding:10px 11px; font-size:14px; font-weight:700; font-family:Barlow,sans-serif; background:#fff; color:#12161C; cursor:pointer;');
P.forEach(function(p){
var o=document.createElement('option');
o.value=p.id; o.textContent=p.name;
if(p.id===cur.id)o.selected=true;
s.appendChild(o);
});
s.addEventListener('change',function(){pickDesign(k,s.value);});
s.addEventListener('click',function(e){e.stopPropagation();});
line.appendChild(s);
return line;
}

function render(){
if(!wrap)return;
wrap.innerHTML='';
ROWS.forEach(function(r){
var on=r.n===sel;
var row=el('div','position:relative; border:2px solid '+(on?'#FF4D14':'#E3E7EC')+'; background:'+(on?'#FFF3EE':'#fff')+'; border-radius:14px; padding:14px 15px; cursor:pointer;'+(on?' box-shadow:0 4px 16px rgba(255,77,20,0.14);':''));

var head=el('div','display:flex; align-items:flex-start; gap:12px;');
head.innerHTML=
'<span style="width:21px; height:21px; border-radius:50%; flex-shrink:0; margin-top:1px; border:2px solid '+(on?'#FF4D14':'#C4CBD3')+'; background:#fff; display:flex; align-items:center; justify-content:center;">'+
(on?'<span style="width:11px; height:11px; border-radius:50%; background:#FF4D14; display:block;"></span>':'')+'</span>'+
'<span style="flex:1; min-width:0;">'+
'<span style="display:flex; align-items:center; gap:8px; flex-wrap:wrap;">'+
'<span style="font-family:Bebas Neue,sans-serif; font-size:19px; letter-spacing:.7px; color:#12161C; line-height:1;">'+r.title+'</span>'+
(r.badge?'<span style="background:#FF4D14; color:#fff; font-size:9.5px; font-weight:800; letter-spacing:.7px; padding:3px 8px; border-radius:999px;">'+r.badge+'</span>':'')+
'</span>'+
'<span style="display:block; font-size:12.5px; color:#5B6672; margin-top:4px;">'+r.sub+'</span>'+
'</span>'+
'<span style="text-align:right; flex-shrink:0;">'+
'<span style="display:block; font-size:19px; font-weight:800; color:'+(on?'#C43100':'#12161C')+'; line-height:1.1;">$'+r.price+'</span>'+
'<span style="display:block; font-size:12.5px; color:#8E98A3; text-decoration:line-through; margin-top:2px;">$'+r.was+'</span>'+
(r.each?'<span style="display:block; font-size:11.5px; color:#5B6672; margin-top:2px;">'+r.each+'</span>':'')+
'</span>';
head.addEventListener('click',function(){if(!on)pickBundle(r.n);});
row.appendChild(head);

if(on){
var body=el('div','margin-top:13px; padding-top:13px; border-top:1px dashed #F0B49A; display:flex; flex-direction:column; gap:9px;');
if(r.n===1){body.appendChild(pickerLine('FACE',0));}
else{for(var k=0;k<r.n;k++)body.appendChild(pickerLine('MASK '+(k+1),k));}
row.appendChild(body);
}

wrap.appendChild(row);
});
}

function build(){
if(built)return true;
var hidden=document.getElementById('if-bundles');
var units=document.getElementById('if-units');
if(!hidden||!units||!P.length)return false;
if(!hidden.querySelectorAll('button').length)return false;
built=true;

var cards=hidden.querySelectorAll('button');
for(var i=0;i<cards.length;i++){
if((cards[i].style.borderColor||'').indexOf('255, 77, 20')>-1){sel=i+1;break;}
}

wrap=el('div','display:flex; flex-direction:column; gap:9px; margin:0 0 16px;');
wrap.id='if-bundlerows';
hidden.parentNode.insertBefore(wrap,hidden);

hidden.style.display='none';
units.style.display='none';
var unitsLabel=units.previousElementSibling;
if(unitsLabel&&unitsLabel.textContent.indexOf('PICK YOUR FACE')>-1)unitsLabel.style.display='none';

render();
if(window.MutationObserver){new MutationObserver(function(){render();}).observe(units,{childList:true});}
return true;
}

var n=0;
var iv=setInterval(function(){n++;if(build()||n>80)clearInterval(iv);},100);
if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();
